import Home from "../components/Home"
import Layout from "../components/layout"

export default () => {
  return (
    <Layout page="/">
      <Home />
    </Layout>
  )
}
